import { createRouter, parseSearchWith, stringifySearchWith } from '@tanstack/react-router'
import { Json } from 'ox'

import { routeTree } from './routeTree.gen'

const parse = parseSearchWith(Json.parse)
const stringify = stringifySearchWith(Json.stringify)

export function getRouter() {
  return createRouter({
    routeTree,
    scrollRestoration: true,
    parseSearch: (str) => {
      const result = parse(str) as Record<string, unknown>
      // `_decoded` is a derived field added by the accounts SDK's
      // `Remote.validateSearch`. Persisting it to the URL causes a 307 loop on
      // SSR reload (e.g. after vite HMR full-reloads the iframe) because the
      // re-derived value's stringified form drifts slightly from the URL copy.
      // Strip it on parse so validateSearch always recomputes fresh.
      delete result._decoded
      // The accounts SDK iframe URL encodes `jsonrpc=2.0` raw, which
      // `Json.parse` reads as the number `2`. `Remote.validateSearch` then
      // forces `jsonrpc: '2.0'` (string), which re-stringifies differently
      // than the URL — TanStack Start sees a mismatch and 307-redirects to
      // canonical, forever. Pre-normalize to the string form so input matches
      // validateSearch's output.
      if (typeof result.jsonrpc === 'number') result.jsonrpc = String(result.jsonrpc.toFixed(1))
      return result
    },
    stringifySearch: (search) => {
      const { _decoded, ...rest } = search as Record<string, unknown>
      return stringify(rest)
    },
  })
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof getRouter>
  }
}
